import { HashRouter as Router, Routes, Route, Navigate} from 'react-router-dom';

import './App.css';
import DetailPage from './modules/detail/DetailPage';
import LotScanner from './modules/lotscanner/LotScanner';
import MachineLocation from './modules/machinelocation/MachineLocation';
import Overview from './modules/overview/Overview';
import UploadMultipress from './modules/uploadmultipress/UploadMultipress';
import WasteDetail from './modules/wastedetail/WasteDetail';
import WasteOverview from './modules/wasteoverview/WasteOverview';
import Report from './modules/report/Report';
import ContainerDetail from './modules/containerdetail/ContainerDetail';
import ContainerOverview from './modules/containeroverview/ContainerOverview';
import ReportDetail from './modules/reportdetail/ReportDetail';

// comemented routes are for overview pages used for development purposes (quicker to run only this application instead of the my smart comp admin FE)
// if you devolop overview pages here, doe not forget to add them to the admin FE project
const App = () => {
  return (
    <div className="App">
      <Router>
        <Routes>
          {/*<Route path='/report/:id' element={<ReportDetail />} />*/}
          {/*<Route path='/report' element={<Report />} />*/}
          {/*<Route path='/upload' element={<UploadMultipress />} />*/}
          {/*<Route path='/machine' element={<MachineLocation />} />*/}
          <Route path='/scan' element={<LotScanner />} />
          {/*<Route path='/lot/:id/order/:order' element={<DetailPage />} />*/}
          {/*<Route path='/lot' element={<Overview />} />*/}
          {/*<Route path='/waste/:id' element={<WasteDetail />} />*/}
          {/*<Route path='/waste' element={<WasteOverview />} />*/}
          {/*<Route path='/container/:id' element={<ContainerDetail />} />*/}
          {/*<Route path='/container' element={<ContainerOverview />} />*/}
          <Route path='/' element={<Navigate to='/scan' />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
